import React from "react";
import { pageTitle } from "../PageTitle";
import BreadCrumb from "../BreadCrumb";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link } from "react-router-dom";
import portfolio1 from "../../assets/images/resource/portfolio-1.png";
import portfolio2 from "../../assets/images/resource/portfolio-2.png";
import portfolio3 from "../../assets/images/resource/portfolio-3.png";
import project from "../../assets/images/resource/project-details-4.jpg";

const Emp_Payroll_Preparation = () => {
  pageTitle("Employee Payroll Preparation");
//   const projrctData = [
//     {
//       id: 1,
//       image: portfolio1,
//       link: "/projects-details",
//     },
//     {
//       id: 2,
//       image: portfolio2,
//       link: "/Career-Portal",
//     },
//     {
//       id: 3,
//       image: portfolio3,
//       link: "/svayambu",
//     },
//   ];
  return (
    <>
      <HeaderOne></HeaderOne>
      {/* <BreadCrumb></BreadCrumb> */}
      <section className="project__detail p_relative">
        <div className="auto-container">
          {/* <div className="image">
            <figure>
              <img src={project} alt="" />
            </figure>
          </div>
          <div className="pro__info">
            <ul>
              <li>
                <div className="name">
                  <p>Client :</p>
                </div>
                <div className="name__two">
                  <h4>Jone welliam</h4>
                </div>
              </li>
              <li>
                <div className="name">
                  <p>Category :</p>
                </div>
                <div className="name__two">
                  <h4>Marketing</h4>
                </div>
              </li>
              <li>
                <div className="name">
                  <p>Date :</p>
                </div>
                <div className="name__two">
                  <h4>15 July, 2023</h4>
                </div>
              </li>
            </ul>
          </div> */}
          <div className="data">
            <h4>Employee Payroll Preparation</h4>
          </div>
          {/* <p>
            At AI.SIW, we leverage the power of AI to help you achieve your
            career goals with tailored guidance and advanced tools. Our platform
            offers comprehensive services, including:
          </p> */}
          <div className="data">
            {/* <h4>AI Career Guidance & Tools Hub</h4> */}

          </div>
          <h5><span>Data Collection & Consolidation</span></h5>
          <p>
          Collects attendance, overtime, leave, and shift data from HRIS, time system, and Excel files. Pulls variable pay inputs (incentives, commissions, allowances) from different departments. Merges all inputs into a single structured payroll dataset.
          </p>
          <h5><span>Data Validation & Quality Checks</span></h5>
          <p> Verifies employee IDs, cost centers, and pay codes against master data. Checks for missing values, negative hours, duplicate records, or invalid dates. Validates that approved leave and attendance data match (no conflicts).
          </p>
          <h5><span>Policy & Rules Application</span></h5>
          <p>
          Applies company payroll rules (overtime calculation, shift allowance, night allowance, etc.). Calculates payable days, loss-of-pay days, and eligibility for allowances and benefits. Handles pro-rated salary for joiners, resignations, and unpaid leave.
          </p>
          <h5><span>Pre-Payroll Calculations</span></h5>
          <p>
          Computes gross salary, deductions (tax, provident fund, loans), and net pay. Applies statutory deductions as per local regulations. Calculates one-time payments (bonus, ex-gratia) based on defined rules.
          </p>
          <h5><span>Payroll File Generation</span></h5>
          <p> Creates final payroll input files in the required format (CSV/Excel/API payload) for the payroll system. Prepares separate files for salary processing, bank transfers, and statutory submissions if needed
          </p>

          {/* <div className="project__button">
            <div className="button__one">
              <Link to="#">Previous</Link>
            </div>
            <div className="button__one">
              <Link to="#">Next</Link>
            </div>
          </div> */}
        </div>
      </section>
      {/* <div className="project__page p_relative see__pad">
        <div className="auto-container">
          <div className="row">
            {projrctData.map((item, id) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={id}>
                <div className="portfolio__block p_relative">
                  <div className="portfolio__image">
                    <figure>
                      <img src={item.image} alt="" />
                    </figure>
                  </div>
                  <div className="lower__content p_absolute">
                    <div className="protfolio__text">
                      <div className="text__block">
                        <h4>For more projects</h4>
                        <p>Design</p>
                      </div>
                      <div className="text__block_two">

                      </div>
                    </div>
                    <div className="protfolio__button">
                      <Link to={item.link} className="theme-btn theme-btn-one">
                        Read More<i className="icon-02"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      <FooterOne></FooterOne>
    </>
  );
};

export default Emp_Payroll_Preparation;
